module.exports = __webpack_public_path__ + "img/河北大学.0cf0edee.png";